module.exports = __webpack_public_path__ + "static/media/bkg_1.317166d9.jpg";